@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.PageTitle {
  @extend %font-family-primary;

  display: grid;
  row-gap: 8px;
  padding-bottom: 36px;
  font-size: $font-size-normal;
  font-weight: $font-weight-normal;
  color: $theme-color-text;
  margin: 0;
}
